var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfographics2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.136,
    height: 214.116,
    viewBox: "0 0 51.136 214.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(1 1) rotate(180)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f048cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00096"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(1 1) rotate(180)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4982d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285caa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0.357,
    cy: 0.706,
    r: 0.5,
    gradientTransform: "translate(0.714 1.412) rotate(180)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5998f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285caa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0.357,
    cy: 0.706,
    r: 0.5,
    gradientTransform: "translate(0.714 1.412) rotate(180)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4fd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00096"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.821 267.943) rotate(175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.037,88.391a1.9,1.9,0,0,0,2.809-.909C19.2,55.6,26.444,16.577,27.549,2.672A2.364,2.364,0,0,0,25.693.011,1.7,1.7,0,0,0,25.5,0a2.231,2.231,0,0,0-2.046,2.213C22.373,15.776,15.289,53.872.272,85.059A2.7,2.7,0,0,0,1.037,88.391Z",
    transform: "translate(29.683 163.469)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,71.635C0,80.01,5.851,86.8,13.068,86.8S26.136,80.01,26.136,71.635c0-7.12-4.229-13.09-9.931-14.721A226.583,226.583,0,0,0,9.877,1.749,2.131,2.131,0,0,0,7.9,0a1.8,1.8,0,0,0-.553.088,2.455,2.455,0,0,0-1.432,2.94,221.17,221.17,0,0,1,6.182,53.49C5.331,57.1,0,63.642,0,71.635Z",
    transform: "translate(41.71 82.213)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.675,
    cy: 3.675,
    rx: 3.675,
    ry: 3.675,
    transform: "translate(64.479 167.787)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.675,
    cy: 3.675,
    rx: 3.675,
    ry: 3.675,
    transform: "translate(41.71 265.265)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.675,
    cy: 3.675,
    rx: 3.675,
    ry: 3.675,
    transform: "translate(63.674 69.076)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.407,
    cy: 14.407,
    rx: 14.407,
    ry: 14.407,
    transform: "translate(15.04 237.53)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.407,
    cy: 14.407,
    rx: 14.407,
    ry: 14.407,
    transform: "translate(40.5 139.185)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.407,
    cy: 14.407,
    rx: 14.407,
    ry: 14.407,
    transform: "translate(32.637 59.408)",
    fill: "url(#d)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographics2);
export default __webpack_public_path__ + "static/media/Infographics2.09a11a419ec85b19485ffa133484e60e.svg";
export { ForwardRef as ReactComponent };